<template>
    <section class="tasks-card" v-if="tasks">
        <ul class="bullet-line-list">
            <!-- organization overview -->
            <li>
                <div class="d-flex justify-content-between">
                    <div>
                      <span :class="getStatusClass(tasks.org_overview.status)">1. Organization Overview Form</span>
                      <span v-if="orgViewForm" class="ml-1">[ <a :href="orgViewForm">Complete Form</a> ]</span>
                      <span v-if="orgEditForm" class="ml-1">[ <a :href="orgEditForm">View Entry</a> ]</span>
                  </div>
                  <p><task-status :task_status="tasks.org_overview.status"></task-status></p>
                </div>
            </li>
            <!-- end organization overview -->

            <!-- account approval -->
            <li>
                <div class="d-flex justify-content-between">
                  <div><span :class="getStatusClass(tasks.account_approval.status)">2. Accreditation Fee Approval</span></div>
                  <p><task-status :task_status="tasks.account_approval.status"></task-status></p>
                </div>
            </li>
            <!-- end account approval -->

            <!-- create application -->
            <li>
                <div class="d-flex justify-content-between">
                  <div>
                    <span :class="getStatusClass(tasks.create_application.status)">3. Create Application</span>
                    <span v-if="needsApplication" class="ml-1">[ <a :href="companyPageUrl">Create Application</a> ]</span>
                  </div>
                  <p><task-status :task_status="tasks.create_application.status"></task-status></p>
                </div>
            </li>
            <!-- end create application -->

            <!-- payment status -->
            <li>
                <div class="d-flex justify-content-between">
                  <div>
                    <span :class="getStatusClass(tasks.payment_status.status)">4. Submit Payment</span>
                    <span v-if="unpaid" class="ml-1">[ <a :href="applicationsPageUrl">Add Fee to Cart</a> ]</span>
                </div>
                  <p><task-status :task_status="tasks.payment_status.status"></task-status></p>
                </div>
            </li>
            <!-- end payment status -->

            <!-- in process -->
            <li>
                <div class="d-flex justify-content-between">
                  <div>
                      <span :class="getStatusClass(tasks.in_process.status)">5. Application In-Process</span>
                  </div>
                  <p><task-status :task_status="tasks.in_process.status"></task-status></p>
                </div>
            </li>
            <!-- end in process -->

            <!-- in review -->
            <li>
                <div class="d-flex justify-content-between">
                  <div>
                      <span :class="getStatusClass(tasks.in_review.status)">6. Application In-Review</span>
                  </div>
                  <p><task-status :task_status="tasks.in_review.status"></task-status></p>
                </div>
            </li>
            <!-- end in review -->

            <!-- accredited -->
            <li>
                <div class="d-flex justify-content-between">
                  <div>
                      <span :class="getStatusClass(tasks.accredited.status)">7. Application Accredited</span>
                  </div>
                  <p><task-status :task_status="tasks.accredited.status"></task-status></p>
                </div>
            </li>
            <!-- end accredited -->

        </ul>
        <div class="list align-items-center"></div>
    </section>
</template>
<script>
    import TaskStatus from './TaskStatus.vue';

    export default {
        props: ['tasks'],
        components: {
            TaskStatus
        },
        methods: {
            getStatusClass(status) {
                if( status == 0 )
                    return ['text-inactive'];

                if( status == 1 )
                    return ['text-pending'];

                if( status == 2 )
                    return ['text-complete'];

                return ['text-inactive'];
            }
        },
        computed: {
            orgViewForm() {
                let data = this.tasks.org_overview.data;

                if (!data)
                    return null;
                if (!data.link)
                    return null;
                if (!data.link[0])
                    return null;
                
                // If entry_id is null, show the link to complete the form
                if (!data.link[0].entry_id) {
                    return data.link[0].link;
                }
                
                return null;
            },
            orgEditForm() {
                let data = this.tasks.org_overview.data;

                if (!data)
                    return null;
                if (!data.link)
                    return null;
                if (!data.link[0])
                    return null;
                
                // Only show edit link if entry_id exists
                if (data.link[0].entry_id) {
                    return data.link[0].view_link;
                }
                
                return null;
            },
            needsApplication() {
                let accountApproved = this.tasks.account_approval.status == 2;
                let noApplication = this.tasks.create_application.status == 0 || this.tasks.create_application.status == 1;

                return accountApproved && noApplication;
            },
            unpaid() {
                let applicationCreated = this.tasks.create_application.status == 2;
                let unpaid = this.tasks.payment_status.status == 0 || this.tasks.payment_status.status == 1;

                return applicationCreated && unpaid;
            },
            companyPageUrl() {
                return localized.homeurl + '/company';
            },
            applicationsPageUrl() {
                return localized.homeurl + '/application';
            }
        }
    }
</script>
